export default __webpack_public_path__ + "static/media/LUSCIOUS_LEOPARD_LOGO.71fc1f6f.png";